<template>
  <div class="dutyAreaPage">
    <div class="forestMap" v-if="param.showMap">
      <!-- 地图页 -->
      <map-locator :param="mapData" mode="h5"></map-locator>
    </div>
    <div :class="['forestTab', this.param.showMap == false ? 'SmallTab' : '']">
      <van-tabs v-model="activeName">
        <van-tab title="责任区信息" name="dutyAreatMsg" class="baseMsg">
          <duty-area-msg :dataInfo="paramData"></duty-area-msg>
        </van-tab>
        <van-tab title="资源信息" name="dutyMsg" class="baseMsg">
          <!-- <pub-resource></pub-resource> -->
          <my-record :dataInfo="paramData"></my-record>
        </van-tab>
        <!-- <van-tab
          v-for="(item, index) in msgList"
          :key="item.id"
          :title="item.postName"
          :name="'dutyArea' + index"
          class="baseMsg"
        >
          <duty-area-policy :dataInfo="item"></duty-area-policy>
        </van-tab> -->
        <van-tab
          title="电子公示牌"
          name="dutyAreaPublicity"
          class="dutyAreaPublicity"
        >
          <duty-area-publicity :dataInfo="paramData"></duty-area-publicity>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
const mapLocator = () => import("@/components/map/MapLocator");
const refreshPage = () => import("@/components/common/refreshPage");
const myRecord = () =>
  import("@/components/linLongModule/linDetailModule/myRecord");
const dutyAreaMsg = () =>
  import("@/components/linLongModule/linDetailModule/zrqAreaMsg");
const zqAreaMsg = () =>
  import("@/components/linLongModule/linDetailModule/zqAreaMsg");
const dutyAreaPolicy = () =>
  import("@/components/linLongModule/linDetailModule/areaPolicy");
const areaAffiliation = () =>
  import("@/components/dutyAreaModule/areaAffiliation");
const dutyAreaPublicity = () =>
  import("@/components/dutyAreaModule/commonPublicity");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";

export default {
  name: "dutyArea",
  data() {
    return {
      dutyAreaId: "", //objId
      gridLevel: "", //责任区等级
      gridType: "", //责任区类型
      gridZqcode: "",
      mapData: {
        type: "",
        objid: "",
      },
      paramData: {
        objid: "",
        level: "",
        zqCode: "",
        type: "",
      },
      interiorPoint: "",
      msgList: [], //根据责任区|政区获取文本信息list
      activeName: "dutyAreatMsg", //默认选中第一项
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  components: {
    dutyAreaMsg,
    zqAreaMsg,
    areaAffiliation,
    dutyAreaPublicity,
    dutyAreaPolicy,
    mapLocator,
    myRecord,
  },
  mounted() {
    document.title = "资源信息";
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      
      this.dutyAreaId = this.$route.query.commonId;
      this.gridLevel = this.$route.query.zqLevel;
      this.gridZqcode = this.$route.query.zqCode;
      let type=this.$route.query.type;
      this.mapData.type = this.getGridType(this.gridLevel,type);
      this.mapData.objid = this.$route.query.commonId;
      console.log(this.$route.query,this.mapData,'2222222mapData1111111');
      if (JSON.stringify(this.param) === "{}") {
        this.param.showMap = true;
        // this.getGridArchives(
        //   this.getGridType(this.gridLevel),
        //   this.gridLevel,
        //   this.dutyAreaId,
        //   this.gridZqcode
        // );

        this.paramData.objid = this.dutyAreaId;
        this.paramData.level = this.gridLevel;
        this.paramData.zqCode = this.gridZqcode;
        this.paramData.type = this.$route.query.type;
      }
      if (this.dutyAreaId == undefined) {
        this.mapData.type = this.param.type;
        this.mapData.objid = this.param.id;
        this.paramData.objid = this.param.id;
        this.paramData.level = this.param.level;
        this.paramData.zqCode = this.param.zqCode;
        this.paramData.type = this.param.type;
        // this.getGridArchives(
        //   this.param.type,
        //   this.getLevel(this.param.type),
        //   this.param.id,
        //   this.param.zqCode
        // );
      }
      console.log(this.mapData,'mapData1111111',this.paramData);
    });
  },
  methods: {
    getLevel(type) {
      //获取责任区等级
      let grade = "";
      if (type == "geo_grid_sheng" || type == "geo_sheng") {
        grade = "1";
      } else if (type == "geo_grid_shi" || type == "geo_shi") {
        grade = "2";
      } else if (type == "geo_grid_xian" || type == "geo_xian") {
        grade = "3";
      } else if (type == "geo_grid_xiang" || type == "geo_xiang") {
        grade = "4";
      } else {
        grade = "5";
      }
      return grade;
    },
    getGridType(grid,zqType) {
      let type = "";
      if (grid == "1") {
        type = "geo_grid_sheng";
      } else if (grid == "2") {
        type = "geo_grid_shi";
      } else if (grid == "3") {
        type = "geo_grid_xian";
      } else if (grid == "4") {
        type = "geo_grid_xiang";
      } else {
        type = "geo_grid_cun";
      }
      zqType=='zq'?type=type.replace('_grid',''):'';
      return type;
    },
    // getGridArchives(type, level, objid, zqCode) {
    //   let _this = this;
    //   console.log(22222);
    //   _this.$api.universal.dutyArea
    //     .getGridArchives({
    //       type: type,
    //       level: level,
    //       objid: objid,
    //       zqCode: zqCode,
    //     })
    //     .then((res) => {
    //       if (res.code == "1" && res.data != null) {
    //         _this.msgList = res.data;
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        console.log("9977554");
        // this.paramData.objid = this.param.id;
        // this.paramData.level = this.param.type;
        // this.paramData.zqCode = this.param.zqCode;
        // this.paramData.type = this.param.type;
        this.mapData.type = this.param.type;
        this.mapData.objid = this.param.id;
        this.paramData.objid = this.param.id;
        this.paramData.level = this.param.level;
        this.paramData.zqCode = this.param.zqCode;
        this.paramData.type = this.param.type;
        // this.getGridArchives(
        //   this.param.type,
        //   this.paramData.level,
        //   this.param.id,
        //   this.param.zqCode
        // );
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.dutyAreaPage {
  width: 100%;
  height: 100%;

  .forestMap {
    width: 100%;
    height: 40%;
    > div {
      height: 100%;
    }
  }

  .forestTab {
    width: 100%;
    height: 60%;
    .van-tabs {
      height: 100%;
      overflow: hidden;

      .van-tabs__line {
        background-color: #4bc08a;
      }

      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }

      .van-tabs__wrap {
        height: 45px;
      }

      .van-tabs__content {
        width: 100%;
        height: 89%;
        overflow-y: scroll;

        .van-tab__pane {
          width: 100%;
        }

        .baseMsg.van-tab__pane,
        .dutyAreaEvaluate.van-tab__pane,
        .dutyAreaPublicity.van-tab__pane,
        .dutyAreaPolicy.van-tab__pane {
          height: 100%;
          background-color: #f6f6f6;
        }
      }
    }
  }
  .forestTab.SmallTab {
    height: 100%;
  }
}
</style>